var map = {
	"./mobile/Ellipse.png": "./src/components/LandingPages/images/contact/mobile/Ellipse.png",
	"./tab/Ellipse.png": "./src/components/LandingPages/images/contact/tab/Ellipse.png",
	"./web/Ellipse.png": "./src/components/LandingPages/images/contact/web/Ellipse.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/LandingPages/images/contact sync recursive ^.*Ellipse\\.png$";